module.exports = __webpack_public_path__ + "static/media/referralOff_326.fd50f9bb.png";